import { Component, Injector } from '@angular/core';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { RequestTypeService} from '../../../ve/ve.service';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-request',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class RequestTypeComponent extends BaseGridComponent {

  public descMaxLength: number = null;

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: RequestTypeService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.descMaxLength = 50;
    this.appCardTitle = 'Request Types';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'Description',
        title: 'Description',
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      Description: ['', Validators.required],
      IsActive: [],
    });
  }
}
